import React from 'react'
import Progress from '../components/Progress.js';
import ExtrasList from '../components/ExtrasList.js';
import Upgrade from '../components/Upgrade.js';
import Bill from '../models/Bill.js';
import RezCentral from '../components/RezCentral.js';
import SCR from '../components/SCR.js';
import {Button, Table/*, Container, Row, Col*/} from 'react-bootstrap/';

export default class Step3 extends React.Component {

  //extrasSelected = [];
  extrasQuickCalcList = {};

  constructor(props){
      super(props);

      this.state = {
        extrasList : [],
        bill : new Bill(),
        extrasSelected : [],
        upgradeList : []
        //price : 0
      }

      this.getBill = this.getBill.bind(this);
      this.handleReserve = this.handleReserve.bind(this);
  }

  componentDidUpdate(){
    SCR.resizeParent();
  }

  componentDidMount() {
    var self = this;

    RezCentral.getExtras(this.props.pickup.locationId)
    .then(data => {

      if(typeof data.data.dailyExtras !== "undefined" && data.data.dailyExtras !== null){
        self.setState({extrasList : data.data.dailyExtras}, () => {
          //this.getBill(this.props.extrasSelected);

          //SCR.resizeParent();
          // set up list for quick rate lookups on display
          // [ "002" : { amount : "0.00" } ]
          this.state.extrasList.forEach(extra => {
            var obj2 = {};
            obj2.amount = extra.extraAmount;
            this.extrasQuickCalcList[extra.extraCode] = obj2;
          });
        });
      }
    });
  }


  getBill(extras){
    var self = this;

    var billData = {
      //confirmationNum : this.props.confirmationNum,
      pickupLocationId : this.props.pickup.locationId,
      dropoffLocationId : this.props.dropoff.locationId,
      pickupDateTime : this.getDateString(this.props.pickup.date) + ' ' + this.props.pickup.time,
      dropoffDateTime : this.getDateString(this.props.dropoff.date) + ' ' + this.props.dropoff.time,
      discountCode : this.props.discountCode,
      classCode : this.props.vehicleClass.classCode,
      rateId : this.props.vehicleClass.rateId,
      extras : extras
    };

    RezCentral.getBill(billData)
    .then(data => {
      if(data.data !== ""){
        self.setState({
            bill : data.data,
            extrasSelected : extras
        }, () => {
          //SCR.resizeParent();

          // upgrade list
          if(!this.props.vehicleClass.isUpgrade)
            this.getUpgradeList(this.state.bill.rateCharge);
        });
      }
    });
  }

  getUpgradeList(totalCharges){
    //var self = this;
    var upgradeList = [];
    //var rentalList = [];

    var rateData = {
      pickupLocationId : this.props.pickup.locationId,
      dropoffLocationid : this.props.dropoff.locationId,
      pickupDateTime : this.getDateString(this.props.pickup.date) + ' ' + this.props.pickup.time,
      dropoffDateTime : this.getDateString(this.props.dropoff.date) + ' ' + this.props.dropoff.time,
      discountCode : this.props.discountCode,
      extras : this.props.extras
    };

    RezCentral.getRates(rateData)
    .then(data => {
      var rentalList = [];
      if(typeof data.data.rateProduct !== "undefined")
        rentalList = data.data.rateProduct;

      rentalList.forEach(rental => {
          //console.log(rental.totalPricing.rateCharge + ' ' + totalCharges)
          if(parseFloat(rental.totalPricing.rateCharge) > totalCharges)
            upgradeList.push(
              {
                classCode : rental.classCode,
                classDesc : rental.classDesc,
                rateId : rental.rateID,
                modelDesc : rental.modelDesc,
                total : rental.totalPricing.totalCharges,
                img : rental.classImageURL.toLowerCase()
              });
      });
      if(upgradeList.length > 0)
        this.setState({ upgradeList : upgradeList}//, () => {SCR.resizeParent();}
        );
    });
  }

  handleReserve(){
    //console.log('EXTRAS SELECTED')
    //console.log(this.state.extrasSelected)
    this.props.setExtraOptions(this.state.extrasSelected);
  }

  getDateString(d){
    if(d === '')
      return '';

    return ('0' + (d.getMonth()+1)).slice(-2) + ('0' + d.getDate()).slice(-2) + d.getFullYear();
  }

  render(){
    //console.log('Step 3 render called');
    let Discount = [];
    if(this.state.bill.rateDiscount !== null){
      Discount = <tr>
        <td>Discount</td>
        <td></td>
        <td>{this.state.bill.rateDiscount}</td>
      </tr>;
    }

    //console.log('DAILY EXTRAS')
    //console.log(this.state.bill.dailyExtras)
    let Extras = [];
    if(typeof this.state.bill.dailyExtras !== 'undefined' ){
      let extras = this.state.bill.dailyExtras;
      //console.log('DAILY EXTRAS')
      //console.log(this.state.bill.dailyExtras)
      Extras = extras.map(
        (extra, index) =>
          <tr key={extra.extraCode + '-' + index}>
            <td>{extra.extraDesc}</td>
            <td>{this.extrasQuickCalcList[extra.extraCode] ? this.extrasQuickCalcList[extra.extraCode].amount : ''}</td>
            <td>{extra.extraAmount}</td>
          </tr>
      );
    }

    let Taxes = [];
    if(typeof this.state.bill.taxes !== 'undefined'){
      let taxes = this.state.bill.taxes;
      if(typeof taxes === 'object'){

        Taxes.push(<tr key={taxes.tax1Desc + '-' + Math.random()}>
                    <td>{taxes.tax1Desc} ({(taxes.tax1Rate * 100).toFixed(2)} %)</td>
                    <td></td>
                    <td>{taxes.tax1Charge}</td>
                  </tr>);
        if(taxes.tax2Desc !== ''){
          //console.log("TAX 2 = "+taxes.tax2Desc)
          Taxes.push(<tr key={taxes.tax2Desc + '-' + Math.random()}>
                      <td>{taxes.tax2Desc} ({(taxes.tax2Rate * 100).toFixed(2)} %)</td>
                      <td></td>
                      <td>{taxes.tax2Charge}</td>
                    </tr>);
        }

      }else/* if(typeof taxes === 'array')*/{
        Taxes = taxes.map(
          (tax, index) => {
            //console.log("TAX 2 = "+tax.tax2Desc)
            return(
              <tr key={tax.tax1Desc + '-' + index}>
                <td>{tax.tax1Desc} ({tax.tax1Rate * 100} %)</td>
                <td></td>
                <td>{tax.tax1Charge}</td>
              </tr>
            );
          });
      }
    }

    var UnlimitedMiles, UpgradeOptions = [];

    if(!this.props.isModifyRez && this.state.upgradeList.length > 0 /*&& !this.props.vehicleClass.isUpgrade*/)
      UpgradeOptions = <Upgrade currentClass={this.props.vehicleClass} getBill={this.getBill} upgradeList={this.state.upgradeList} totalCharges={this.state.bill.totalCharges} setUpgradeClass={this.props.setUpgradeClass} />;

    return (
      <div>
        <Progress pickup={this.props.pickup} dropoff={this.props.dropoff} vehicleClass={this.props.vehicleClass} extras={this.props.extras} returnToStep={this.props.returnToStep} currentStep={this.props.currentStep} isModifyRez={this.props.isModifyRez} price={this.state.bill.totalCharges} personalInfo={this.props.personalInfo} />

        {UpgradeOptions}

        <div id="extras">
          <ExtrasList extrasList={this.state.extrasList} getBill={this.getBill} extrasSelected={this.props.extras} />
        </div>

        <Table id="totals" striped  /*className="table table-striped"*/>
            <thead>
              <tr>
                <td className="total-heading">Details</td><td className="total-heading">Rate</td><td className="total-heading">SubTotal</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{this.state.bill.ratePlan + ' Rate ' + this.state.bill.rentalDays} DAY(s)</td>
                <td>{this.state.bill.ratePeriod ? this.state.bill.ratePeriod.rate1PerDay : "0.00"}</td>
                <td>{this.state.bill.rateCharge}</td>
              </tr>
              {Discount}
              <tr>
                <td>SURCHARGE</td>
                <td></td>
                <td>{this.state.bill.surcharge}</td>
              </tr>
              {Extras}
              {UnlimitedMiles}
              {Taxes}
              <tr>
                <td><b>TOTAL:</b></td>
                <td></td>
                <td>${this.state.bill.totalCharges}</td>
              </tr>
            </tbody>
        </Table>

        <Button className="reserve-button" onClick={this.handleReserve}>Reserve</Button>
    </div>
    );
  }
}
